<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-07-01 11:40:21 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-23 17:30:41 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/exhibit-card/src/izt-exhibit-card.vue
 * @Description  : 展品卡片
-->
<style lang="scss" scoped>
.izt-exhibit-card-container {
  background: #FFFFFF;
  box-shadow: 0px 5px 6px 0px rgba(0,0,0,0.1);
  border-radius: 24px;
  min-height: 0;
  overflow: hidden;
  color: rgba($color: #000000, $alpha: 0.65);
  .head-area-container {
    .exhibitor-name {
      padding: 24px;
      padding-bottom: 16px;
      font-weight: 500;
      font-size: 24px;
    }
    .exhibition-name {
      padding: 16px 24px;
      background-color: var(--izt-theme-color);
      color: var(--izt-theme-text-color-65);
      font-weight: bold;
      font-size: 28px;
    }
  }
  .main-container {
    padding: 24px;
    .rec-short {
      margin: 16px 0;
    }
    .description {
      font-weight: 400;
      font-size: 26px;
      color: rgba(0,0,0,0.65);
      display: -webkit-box;
      overflow: hidden;
      line-clamp: 3;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .booth-number {
      display: flex;
      align-items: center;
      margin-top: 16px;
      .label {
        font-weight: 400;
        font-size: 22px;
        color: rgba(0,0,0,0.45);
      }
      .value {
        display: flex;
        align-items: center;
        gap: 4px;
        font-weight: 500;
        font-size: 22px;
        color: rgba(0,0,0,0.65);
        .label_text {
          text-decoration: underline;
        }
        .map-icon {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
</style>

<template>
  <div class="izt-exhibit-card-container" @click.stop="emit('click', {data, type: 'exhibit'})">
    <div class="head-area-container">
      <div class="exhibitor-name">{{ data.exhibitorname }}</div>
      <div class="exhibition-name">{{ data.productname }}</div>
    </div>
    <div class="main-container">
      <izt-album :list="icon" size="large" preview />
      <div class="rec-short" v-if="data.recommend_reason">
        <izt-ai-rec-short :text="data.recommend_reason" />
      </div>
      <div class="description" v-if="data.introduction">{{data.introduction}}</div>

      <div class="booth-number" v-if="data.exhibitorboothno">
        <div class="label">{{ $t('card.展位号') }}</div>
        <div class="value" v-if="!configStore.otherConfig?.mapConfig?.visible">{{ data.exhibitorboothno }}</div>
        <div class="value" v-else @click.stop="emit('on-map', {data, type: 'exhibit'})">
          <div class="label_text">{{ data.exhibitorboothno }}</div>
          <img class="map-icon" src="@/assets/map-icon.png" mode="aspectFill">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="izt-exhibit-card">
  import { computed } from 'vue'
  import { useConfigStore } from '@/stores/modules/config.js'
  defineOptions({ name: 'izt-exhibit-card' })

  const props = defineProps({
    data: { type: Object, default: () => ({}) }
  })

  const emit = defineEmits(['click', 'on-map'])

  const configStore = useConfigStore()
  const icon = computed(() => {
    if (!props.data.icon) return []
    return props.data.icon.split(',').map(s => s.trim())
  })
</script>